import PumpkinMatcha from "../assets/pumpkin-matcha.jpg";
import SaltedCaramelMatcha from "../assets/salted-caramel-matcha.jpg";
import CherryVanilla from "../assets/cherry-vanilla-matcha.jpg";
import PistachioCreme from "../assets/pistachio-matcha.jpg";
import CoconutCloud from "../assets/coconut-matcha.jpg";
import BobaMatcha from "../assets/matcha-bubble-tea-latte.jpg";
import RoseMatcha from "../assets/rose-matcha.jpg";
import HibiscusMatcha from "../assets/hibiscus-matcha.jpg";
import CharcoalMatcha from "../assets/charcoal-matcha.jpg";
import StrawberryMatcha from "../assets/strawberry-matcha-latte.jpg";
import MangoMatcha from "../assets/mango-matcha-latte.jpg";
import BlueberryMatcha from "../assets/blueberry-matcha.jpg";

export const MenuList = [
    {
        name: "Spiced Pumpkin Matcha",
        image: PumpkinMatcha,
        price: 6.50,
    },
    {
        name: "Salted Caramel Matcha",
        image: SaltedCaramelMatcha,
        price: 6.25,
    },
    {
        name: "Cherry Vanilla Silk Matcha",
        image: CherryVanilla,
        price: 6.50,
    },
    {
        name: "Pistachio Crème Matcha",
        image: PistachioCreme,
        price: 7.50,
    },
    {
        name: "Coconut Cloud Matcha",
        image: CoconutCloud,
        price: 6.00,
    },
    {
        name: "Brown Sugar Boba Matcha",
        image: BobaMatcha,
        price: 6.75,
    },
    {
        name: "Rose Petal Matcha",
        image: RoseMatcha,
        price: 6.25,
    },
    {
        name: "Hibiscus Tonic Matcha",
        image: HibiscusMatcha,
        price: 5.75,
    },
    {
        name: "Charcoal Detox Matcha",
        image: CharcoalMatcha,
        price: 6.50,
    },
    {
        name: "Strawberry Fields Matcha",
        image: StrawberryMatcha,
        price: 6.75,
    },
    {
        name: "Iced Mango Matcha",
        image: MangoMatcha,
        price: 6.50,
    },
    {
        name: "Wild Blueberry Matcha",
        image: BlueberryMatcha,
        price: 6.75,
    },

];